import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { routes } from '../routes/routes';

const RoutingErrorPage = () => {
    const navigate = useNavigate();

    return (
        <ErrorState
            headline={<FormattedMessage id='intl-msg:common-message.error.generic.headline' />}
            message={<FormattedMessage id='intl-msg:common-message.error.generic.message' />}
            buttons={[
                {
                    text: <FormattedMessage id='intl-msg:starterTemplate.reloadPage' />,
                    onClick: () => navigate(routes.STREAMS),
                    className: 'btn-primary',
                },
            ]}
        >
            <FormattedMessage id='intl-msg:common-message.error.generic.retryOrSupport' />
        </ErrorState>
    );
};

export default RoutingErrorPage;
